import React from 'react';
import { scaleLabels } from '../data/assessmentData';

function MatrixQuestionSection({ area, responses, onResponseChange, readOnly = false }) {
  return (
    <div className="w-full">
      {/* Desktop/Tablet Matrix View */}
      <div className="overflow-x-auto bg-white rounded-lg shadow-sm border border-gray-200">
        <table className="w-full min-w-[800px] border-collapse">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-200">
              <th className="text-left p-4 w-1/3 text-gray-700 font-bold uppercase text-xs tracking-wider sticky left-0 bg-gray-50 z-10 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]">
                Question
              </th>
              {scaleLabels.map(scale => (
                <th key={scale.value} className="p-3 text-center w-[9%] align-bottom">
                  <div className="flex flex-col items-center justify-end h-full">
                    <span className="text-[10px] text-gray-500 font-medium uppercase mb-1 rotate-0 whitespace-nowrap">
                      {scale.label}
                    </span>
                    <div className="w-8 h-8 rounded-full bg-white border border-gray-300 flex items-center justify-center text-sm font-bold text-gray-700 shadow-sm">
                      {scale.value}
                    </div>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {area.questions.map((question, index) => {
              const questionId = `${area.id}_${index}`;
              const currentVal = responses[questionId];
              return (
                <tr 
                  key={questionId} 
                  className={`transition-colors border-b border-gray-100 last:border-0 hover:bg-blue-50/30 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/30'}`}
                >
                  <td className="p-4 text-gray-800 font-medium text-sm md:text-base border-r border-gray-100 sticky left-0 bg-inherit z-10 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]">
                    <span className="mr-2 text-gray-400 font-normal">{index + 1}.</span>
                    {question}
                  </td>
                  {scaleLabels.map(scale => (
                    <td key={scale.value} className="p-2 text-center">
                      <label className="cursor-pointer flex items-center justify-center w-full h-full py-4 rounded hover:bg-blue-100/50 transition-colors">
                        <input
                          type="radio"
                          name={questionId}
                          value={scale.value}
                          checked={currentVal === scale.value}
                          onChange={() => !readOnly && onResponseChange(questionId, scale.value)}
                          disabled={readOnly}
                          className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500 cursor-pointer"
                        />
                      </label>
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Mobile-friendly legend below */}
      <div className="mt-4 text-xs text-gray-500 flex justify-between px-2">
        <span>1 = Strongly Disagree</span>
        <span>7 = Strongly Agree</span>
      </div>
    </div>
  );
}

export default MatrixQuestionSection;